import { IScope } from 'angular';
import { FC, useState } from 'react';

import { AngularContext } from './context';

export const AngularContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [scope, setScope] = useState<IScope | null>(null);

  return <AngularContext.Provider value={{ scope, setScope }}>{children}</AngularContext.Provider>;
};
